module.exports = __webpack_public_path__ + "img/1575200589.e6c771a1.jpg";